import {createAction, props} from '@ngrx/store';
import {AuthState} from '../auth/store/auth.reducer';
import {DataState} from './data.reducer';
import {ExerciseState} from '../exercise/store/exercise.reducer';
import {ClientState} from '../client/store/client.reducer';
import {PathologyState} from "../pathology/store/pathology.reducer";

export type PersistedState = { auth: AuthState; data: DataState; exercise: ExerciseState; client: ClientState, pathology: PathologyState };

export const hydrate = createAction('@app/storage/hydrate');
export const hydrateSuccess = createAction('@app/storage/hydrate-success', props<{ state: Partial<PersistedState> }>());
export const hydrateFailure = createAction('@app/storage/hydrate-failure', props<{ error: any }>());
